/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  Space,
  Heading2,
  Box,
  AlignItems,
  BorderStyle,
  Color,
  Display,
  FontFamily,
  FontWeight,
  Icon,
  Text,
  Join,
  LinkVariant,
} from '@gousto-internal/citrus-react'
import { client } from 'src/config/routes'
import { createSlugFromUrl } from 'src/utils'
import { FALLBACK_COLOR, FALLBACK_ICON } from 'src/config/icons'
import { Link } from '../Routing/index'
import type { Section, BackendCategory } from '../../types/entities'
import { hex2rgb } from '../../utils/index'
import { ErrorBoundary } from '../ErrorBoundary'

interface SectionContentPreviewProps {
  sections: Section[]
  category: BackendCategory
}

const SectionContentPreview = ({ sections, category }: SectionContentPreviewProps) => {
  const iconColorLight = category?.icon_color_light

  return (
    <Join append with={<Space size={4} />}>
      {sections.map((section) => {
        const {
          id,
          name,
          iconName,
          htmlURL,
          description,
        } = section
        const sectionSlug = createSlugFromUrl(htmlURL)
        const url = `/help-centre${client.categories}/${section.categoryId}${client.sections}/${sectionSlug}/${section.id}`

        return (
          <Link
            key={id}
            variant={LinkVariant.None}
            href={url}
            display={Display.Block}
            css={{ textDecoration: 'none' }}
          >
            <Box
              borderWidth={0.5}
              borderColor={Color.ColdGrey_100}
              borderStyle={BorderStyle.Solid}
              borderRadius={1}
              paddingH={6}
              paddingV={6}
              display={Display.Flex}
              alignItems={AlignItems.Center}
            >
              <Box
                paddingRight={5}
              >
                <Box
                  borderRadius="round"
                  paddingH={4}
                  paddingV={4}
                  display="inline-flex"
                  width="auto"
                  height="auto"
                  css={{ backgroundColor: `rgba(${hex2rgb(iconColorLight || FALLBACK_COLOR)}, 0.13)` }}
                >
                  <ErrorBoundary fallBackUI={(
                    <Icon
                      name={FALLBACK_ICON}
                      css={{ color: iconColorLight }}
                      size={6}
                    />
                  )}
                  >
                    <Icon
                      name={iconName || FALLBACK_ICON}
                      css={{ color: iconColorLight || FALLBACK_COLOR }}
                      size={6}
                    />
                  </ErrorBoundary>
                </Box>
              </Box>
              <Box>
                <Heading2
                  fontFamily={FontFamily.SemiBold}
                  fontWeight={FontWeight.SemiBold}
                  size={4}
                >
                  {name}
                </Heading2>
                <Space size={2} />
                <Text size={2}>
                  {description}
                </Text>
              </Box>
            </Box>
          </Link>
        )
      })}
    </Join>
  )
}

export { SectionContentPreview }
